import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function MindsetShift() {
  return <section className="py-12 md:py-16 px-4 relative" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-127">
          <p className="text-base md:text-lg text-gray-400 italic" data-id="element-128">
            Algo cambia cuando lo ves así. Dejas de preguntarte una cosa y
            empiezas a preguntarte otra.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 items-stretch" data-id="element-129">
          {/* Before */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="glass-card rounded-2xl p-8 border-red-500/10 relative overflow-hidden" data-id="element-130">
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-gray-500 mb-4" data-id="element-131">
              ANTES
            </div>
            <p className="text-xl md:text-2xl font-display font-medium text-gray-400 leading-snug" data-id="element-132">
              "¿Quién creo que va a ganar?"
            </p>
          </motion.div>

          {/* After */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="glass-card rounded-2xl p-8 border-brand-green/30 relative overflow-hidden" data-id="element-133">
            <div className="absolute top-0 right-0 w-40 h-40 bg-brand-green/10 blur-[60px] rounded-full" data-id="element-134" />
            <div className="relative" data-id="element-135">
              <div className="text-xs font-mono uppercase tracking-[0.2em] text-brand-green mb-4 flex items-center gap-2" data-id="element-136">
                AHORA <ArrowRight className="w-3 h-3" data-id="element-137" />
              </div>
              <p className="text-xl md:text-2xl font-display font-semibold text-white leading-snug" data-id="element-138">
                "¿Qué sugiere realmente el sistema que está ocurriendo?"
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-10 text-center max-w-2xl mx-auto" data-id="element-139">
          <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-140">
            Las decisiones cambian.{' '}
            <span className="text-white" data-id="element-141">
              Más calmadas. Menos reactivas. Más intencionales.
            </span>
          </p>
          <p className="text-sm md:text-base text-gray-500 mt-3 italic" data-id="element-142">
            No porque aumente la certeza — sino porque por fin disminuye el
            ruido.
          </p>
        </motion.div>
      </div>
    </section>;
}